import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var ShopImgDeleteRes;
export const ShopImgDeleteTodo = createAsyncThunk('ShopImgDelete', async (id) => {
    // console.log("data", data)
    try {
        const res = await axios({
            method: "Delete",
            url: process.env.REACT_APP_API_URL + `delete_shop/${id}`,
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + localStorage.getItem('user_token') }
        })
        return ShopImgDeleteRes = res.data

    } catch (error) {
        return ShopImgDeleteRes = error.response.data
    }
})
